module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/图2.d2370d49.png";